import { APIENDPOINT, getCWPEnvironmentForURL } from './common-utils'

const bgColorUtil = {
  /*Brand Colors*/
  ['ameriprise-blue']: {
    hex: '#003f6d',
    bgColor: 'u-bgColorAmpfBlue',
    text: 'u-textColorAmpfBlue',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    button: 'Button--tertiary Button--reversed',
    iconFillColor: 'u-fillAmpfBlue',
  },
  white: {
    hex: '#fff',
    bgColor: 'u-bgColorWhite',
    text: 'u-textColorWhite',
    contrastText: 'u-textColorDefault',
    contrast: '',
    button: 'Button--primary',
    iconFillColor: 'u-fillColorWhite',
  },

  mint: {
    hex: '#44a29a',
    text: 'u-textColorMint',
    bgColor: 'u-bgColorMint',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    button: 'Button--tertiary Button--reversed',
    iconFillColor: 'u-fillColorMint',
  },
  ['dark-mint']: {
    hex: '#007886',
    bgColor: 'u-bgColorDarkMint',
    text: 'u-textColorDarkMint',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    button: 'Button--secondary',
    iconFillColor: 'u-fillColorDarkMint',
  },
  ['light-blue']: {
    hex: '#009fb8',
    text: 'u-textColorLightBlue',
    bgColor: 'u-bgColorLightBlue',
    adelText: 'u-textColorWhite',
    contrastText: 'u-textColorDefault',
    contrast: 'Content--reversed',
    button: 'Button--tertiary Button--reversed',
    iconFillColor: 'u-fillColorLightBlue',
  },
  purple: {
    hex: '#5D378C',
    bgColor: 'u-bgColorPurple',
    text: 'u-textColorPurple',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    button: 'Button--secondary',
    iconFillColor: 'u-fillColorPurple',
  },
  orange: {
    hex: '#F99D19',
    bgColor: 'u-bgColorOrange',
    text: 'u-textColorOrange',
    contrastText: 'u-textColorDefault',
    contrast: '',
    button: 'Button--primary',
    iconFillColor: 'u-fillColorOrange',
  },

  berry: {
    hex: '#972364',
    bgColor: 'u-bgColorBerry',
    text: 'u-textColorBerry',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    button: 'Button--secondary',
    iconFillColor: 'u-fillColorBerry',
  },
  /*Standard*/

  ['grey-light']: {
    hex: '#eaeaea',
    bgColor: 'u-bgColorGreyLight',
    text: '',
    contrastText: 'u-textColorDefault',
    contrast: '',
    button: 'Button--primary',
    iconFillColor: 'u-fillColorGreyLight',
  },
  stone: {
    hex: '#F3F2F1',
    bgColor: 'u-bgColorStone',
    text: '',
    contrastText: 'u-textColorDefault',
    contrast: '',
    button: 'Button--primary',
    iconFillColor: 'u-fillColorStone',
  },
  ['lime-light']: {
    hex: '#f2f7dd',
    bgColor: 'u-bgColorLimeLight20',
    text: '',
    contrastText: 'u-textColorDefault',
    contrast: '',
    button: 'Button--primary',
    iconFillColor: '',
  },
  ['purple-light']: {
    hex: '#edeaf0',
    bgColor: 'u-bgColorPurpleLight10',
    text: '',
    contrastText: 'u-textColorDefault',
    contrast: '',
    button: 'Button--primary',
    iconFillColor: '',
  },
  ['mint-light']: {
    hex: '#ecf6f5',
    bgColor: 'u-bgColorMintLight10',
    text: '',
    contrastText: 'u-textColorDefault',
    contrast: '',
    button: 'Button--primary',
    iconFillColor: '',
  },
  ['light-gray']: {
    hex: '#f4f4f5',
    bgColor: 'u-bgColorLight',
    text: 'u-textColorLight',
    contrastText: 'u-textColorDefault',
    contrast: '',
    button: 'Button--primary',
    iconFillColor: '',
  },
  /*Wayfinding Colors*/
  ['action-blue']: {
    hex: '#046CB8',
    bgColor: 'u-bgColorActionBlue',
    text: 'u-textColorActionBlue',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    button: 'Button--secondary',
    iconFillColor: 'u-fillColorActionBlue',
  },
  ['neutral-grey']: {
    hex: '#1F2226',
    bgColor: 'u-bgColorNeutralGrey',
    text: 'u-textColorNeutralGrey',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    button: 'Button--secondary',
    iconFillColor: 'u-fillColorNeutral',
  },

  /* Charts, Graphs, Data Visualizations & Decorative Icons*/
  ['lime-green']: {
    hex: '#8EA71E',
    bgColor: 'u-bgColorData1',
    text: 'u-textColorData1',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    button: 'Button--secondary',
    iconFillColor: 'u-fillColorData1',
  },

  ['light-mint']: {
    hex: '#7FCBC4',
    bgColor: 'u-bgColorData2',
    text: 'u-textColorData2',
    contrastText: 'u-textColorDefault',
    contrast: '',
    button: 'Button--primary',
    iconFillColor: 'u-fillColorData2',
  },
  ['burnt-orange']: {
    hex: '#D17B00',
    bgColor: 'u-bgColorData6',
    text: 'u-textColorData6',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    button: 'Button--secondary',
    iconFillColor: 'u-fillColorData6',
  },
  grey: {
    hex: '#8E9496',
    bgColor: 'u-bgColorData8',
    text: 'u-textColorData8',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    button: 'Button--secondary',
    iconFillColor: 'u-fillColorData8',
  },
  ['sky-blue']: {
    hex: '#2AA7E1',
    bgColor: 'u-bgColorData10',
    text: 'u-textColorData10',
    contrastText: 'u-textColorDefault',
    contrast: '',
    button: 'Button--primary',
    iconFillColor: 'u-fillColorData10',
  },
  ['aqua-blue']: {
    hex: '#00ACC1',
    bgColor: 'u-bgColorData14',
    text: 'u-textColorData14',
    contrastText: 'u-textColorDefault',
    contrast: '',
    button: 'Button--primary',
    iconFillColor: 'u-fillColorData14',
  },

  ['dark-grey']: {
    hex: 'rgba(31, 34, 38, 0.5)',
    text: 'u-textColorNeutral50',
    bgColor: 'u-bgColorNeutral50',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    iconFillColor: '',
  },

  /* Brand Extension */
  ['midnight-blue']: {
    hex: '#00284A',
    bgColor: 'u-bgColorMidnightBlue',
    text: 'u-textColorMidnightBlue',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    button: 'Button--tertiary Button--reversed',
    iconFillColor: 'u-fillColorMidnightBlue',
  },
  ['emerald-mint']: {
    hex: '#07373F',
    bgColor: 'u-bgBrandExColorEmeraldMint',
    text: 'u-textBrandExColorEmeraldMint',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    button: 'Button--tertiary Button--reversed',
    iconFillColor: '',
  },
  ['amethyst-purple']: {
    hex: '#311B38',
    bgColor: 'u-bgBrandExColorAmethystPurple',
    text: 'u-textBrandExColorAmethystPurple',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    button: 'Button--tertiary Button--reversed',
    iconFillColor: '',
  },
  ['graphite-gray']: {
    hex: '#313130',
    bgColor: 'u-bgBrandExColorGraphiteGray',
    text: 'u-textBrandExColorGraphiteGray',
    contrastText: 'u-textColorWhite',
    contrast: 'Content--reversed',
    button: 'Button--primary',
    iconFillColor: '',
  },
  ['white-facets-top']: {
    hex: '#fff',
    bgColor: 'u-bgColorTransparent',
    text: 'u-textColorWhite',
    contrastText: 'u-textColorDefault',
    contrast: '',
    button: 'Button--primary',
    iconFillColor: '',
  },
  ['white-facets-bottom']: {
    hex: '#fff',
    bgColor: 'u-bgColorTransparent',
    text: 'u-textColorWhite',
    contrastText: 'u-textColorDefault',
    contrast: '',
    button: 'Button--primary',
    iconFillColor: '',
  },
}

export const getValueListBgColor = (color: string): string => {
  const bgColor = bgColorUtil[color.trim() as keyof typeof bgColorUtil]?.bgColor
  return bgColor || 'u-bgColorWhite'
}

export const getValueListContrastColor = (color: string): string => {
  const bgColor = bgColorUtil[color.trim() as keyof typeof bgColorUtil]?.contrast
  return bgColor || 'Content--default'
}

export const getValueListContrastTextColor = (color: string): string => {
  const bgColor = bgColorUtil[color.trim() as keyof typeof bgColorUtil]?.contrastText
  return bgColor || 'u-textColorDefault'
}

export const getValueListHexColor = (color: string): string => {
  const bgColor = bgColorUtil[color.trim() as keyof typeof bgColorUtil]?.hex
  return bgColor || '#2f3033'
}

export const getValueListTextColor = (color: string): string => {
  const bgColor = bgColorUtil[color.trim() as keyof typeof bgColorUtil]?.text
  return bgColor || 'u-textColorDefault'
}

export const getValueListFillColor = (color: string): string => {
  const bgColor = bgColorUtil[color.trim() as keyof typeof bgColorUtil]?.iconFillColor
  return bgColor || 'u-fillColorBrand'
}

export const getValueListBackgroundColorFromFillColor = (fillColor: string): string => {
  const bgColor = Object.values(bgColorUtil).find(
    ({ iconFillColor }) => iconFillColor === fillColor
  )?.bgColor
  return bgColor || 'u-bgColorWhite'
}

export const getValueListTextColorFromFillColor = (fillColor: string): string => {
  const bgColor = Object.values(bgColorUtil).find(
    ({ iconFillColor }) => iconFillColor === fillColor
  )?.text
  return bgColor || 'u-textColorDefault'
}

export const getEstimatedColorForFacet = (facet: string): string => {
  const facetsWithColors: Record<string, string> = {
    ['facet-midnight']: 'midnight-blue',
    ['facet-grey']: 'stone',
    ['midnight-facet']: 'midnight-blue',
    ['grey-facet']: 'stone',
  }

  for (const key in facetsWithColors) {
    if (facet.includes(key)) return facetsWithColors[key]
  }
  return ''
}

export function getBgTheme(
  bannerBackground: { image?: string } = {},
  layoutConfigs: { templateType?: string; template?: string } = {}
): string {
  if (!bannerBackground.image) return 'Light'
  if (
    layoutConfigs.templateType &&
    layoutConfigs.template &&
    layoutConfigs.template == 'light-background-article-template'
  ) {
    return 'Light'
  }
  return 'Dark'
}

export const getBgThemeBasedOnColor = (bgColor: string): string => {
  if (!bgColor) return 'Light'

  // eslint-disable-next-line functional/no-let
  let backgroundColor = bgColor
  if (bgColor.includes('facet')) {
    const estimatedColorFromFacet = getEstimatedColorForFacet(bgColor)
    if (estimatedColorFromFacet) {
      backgroundColor = estimatedColorFromFacet
    }
  }
  return getValueListContrastColor(backgroundColor) === 'Content--reversed' ? 'Dark' : 'Light'
}

export const getFacetImagePath = (
  facetColor: string | undefined,
  options: { isMobile: boolean }
): string => {
  const env = getCWPEnvironmentForURL(window.location.href)

  return `${APIENDPOINT(env).baseGallery}content/gallery/ampmicrosites/facets/hero-facets${
    options.isMobile ? '-mobile' : ''
  }-${facetColor || 'midnight-blue'}.svg`
}

export const getFacetImagePathForIA = (
  facetColor: string | undefined,
  options: { isMobile: boolean }
): string => {
  const env = getCWPEnvironmentForURL(window.location.href)

  return `${
    APIENDPOINT(env).baseGallery
  }content/gallery/ampmicrosites/impact-analyzer/hero_${facetColor}${
    options.isMobile ? '_mobile' : ''
  }.png`
}
